export class ComponentTranslationMapping {
  src: string;
  map: any;

  constructor(_src: string, _map: any) {
    this.src = _src;
    this.map = _map;
  }
}
